import { PropertyValueType } from './Interfaces';

export const DateType: PropertyValueType<Date> = Object.freeze({
    name: 'Date',
    fromString(value: string): [boolean, Date] {
        const dt = new Date(value);
        const ok = !isNaN(dt.getTime());
        return [ok, ok ? dt : null];
    },
    serialize(value: Date): any {
        return value.toISOString();
    },
    deserialize(value: any, defau1t?: Date): Date {
        const [ok, dt] = DateType.fromString(value);
        return ok ? dt : defau1t;
    },
});
